/**
 * App Icon Helper
 * Returns the appropriate icon for an app based on app_id
 */

import { Icon } from "@introist/react-foundation/v2";
import { WorktimeIcon } from "../assets";

export const getAppIcon = (appId: string, size?: number) => {
  if (appId.startsWith("worktime")) {
    return <WorktimeIcon width={size} height={size} />;
  }

  // Default icon for unknown apps
  return <Icon name="robot" />;
};
